import { render, staticRenderFns } from "./repasses-medicos.vue?vue&type=template&id=3f0a86c2"
import script from "./repasses-medicos.vue?vue&type=script&lang=js"
export * from "./repasses-medicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports